import React from 'react';
import classNames from 'classnames';
import Logo from '../../../../../../common/Logo';
import getServiceProperty from '../../../../../../../helpers/getServiceProperty';
import styles from './Header.scss';

function Header({ service, size }) {
  const serviceType = getServiceProperty(service.id, 'type');

  return (
    <div className={styles.root}>
      <div className={styles.top}>
        <Logo className={styles.logo} logoName="my-account-secondary" />
        <h3
          className={classNames(
            styles.title,
            styles[size],
            styles[serviceType.toLowerCase()],
          )}
          >{service.title}
        </h3>
      </div>
      <div className={styles.description}>
        <div className={styles.heading}>
          <span
            className={classNames(styles.price, styles[service.periodUnit.toLowerCase()])}
          >
            {service.price}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Header;
